import { Storage } from '@capacitor/storage';

// JSON "set" example
export const setObject = async (key, value) => {
  await Storage.set({
    key,
    value: JSON.stringify(value),
  });
};

// JSON "get" example
export const getObject = async (key) => {
  const ret = await Storage.get({
    key,
  });
  const data = JSON.parse(ret.value);
  return data;
};

export const setItem = async (key, value) => {
  await Storage.set({
    key,
    value,
  });
};

export const getItem = async (key) => {
  const { value } = await Storage.get({
    key,
  });
  return value;
};

export const removeItem = async (key) => {
  await Storage.remove({
    key,
  });
};

export const keys = async () => {
  const { keyData } = await Storage.keys();
  return keyData;
};

export const clear = async () => {
  await Storage.clear();
};
